import * as R from 'ramda';
import { generateRowId } from '..';

const createSearchData = (body) => {
  let searchData = [];

  body.map((section) => {
    let sectionGroup = {
      groupTitle: '',
      data: []
    };

    const sectionTitle = section.title;

    sectionGroup['groupTitle'] = sectionTitle;

    section.data.map((d) => {
      if (
        d.type === 'paragraph' ||
        d.type === 'raw' ||
        d.type === 'caption' ||
        d.type === 'footnote' ||
        d.type === 'list'
      ) {
        sectionGroup['data'].push({
          type: 'text',
          section: sectionTitle,
          text: d.content,
          rowId: generateRowId(sectionTitle, d.content)
        });
      } else if (d.type === 'table') {
        d.content.data.map((row, rowIndex) => {
          const tableRow = row.nestedContent
            ? R.omit(['nestedContent'], row)
            : row;

          let text = '';
          const plainContent = [];

          for (const key of d.content.columns) {
            const value = tableRow[key];
            text += `${key}:${value} `;
            plainContent.push(value);
          }

          const rowId = generateRowId(sectionTitle, tableRow, rowIndex);

          sectionGroup.data.push({
            type: 'table',
            rowId: rowId,
            text: text,
            plainRow: plainContent.join(' '),
          });
        });
      }
    });

    searchData.push(sectionGroup);
  });

  // Section Titles
  const sectionsData = {
    groupTitle: 'Sections',
    data: []
  };
  body.map((section) => sectionsData['data'].push(section.title));
  searchData.push(sectionsData);

  return searchData;
};

export default createSearchData;
